import {
    SEARCH_MENU_AND_ITEMS_START,
    SEARCH_MENU_AND_ITEMS_SUCCESS,
    SEARCH_MENU_AND_ITEMS_ERROR,
} from '../../../constants';

import searchQuery from './searchMenuAndItems.graphql';

export default function searchMenuAndItems({ searchList, menuPage, itemPage }) {
    return async (dispatch, getState, { client }) => {
        dispatch({
            type: SEARCH_MENU_AND_ITEMS_START,
        });

        try {
            const { data } = await client.query({
                query: searchQuery,
                variables: { searchList, menuPage, itemPage },
            });

            if (data) {
                dispatch({
                    type: SEARCH_MENU_AND_ITEMS_SUCCESS,
                    payload: data.searchMenuAndItems,
                });
            }
        } catch (error) {
            dispatch({
                type: SEARCH_MENU_AND_ITEMS_ERROR,
                payload: {
                    error,
                },
            });
            return false;
        }

        return true;
    };
}